export default {
  constructionCard: 'Объектная карта',
  constructionCards: 'Объектные карты',
  editConstructionCard: 'Редактирование объектной карты',
  onlyActual: 'Только актуальные',
  constructionCardShort: 'ОК',
  createNewConstructionCard: 'Создать новую объектную карту',
  newConstructionCard: 'Новая объектная карта',
  stageNotSelected: 'Этап не выбран',
  unitNotSelected: 'Единица измерения не выбрана',
  customerDependent: 'Для выбора контакта из списка сначала укажите подрядчика',
  objectManager: 'Объектный менеджер',
  additionalObjectManager: 'Дополнительный ОМ',
  productDescription: 'Описание товара',
  firstShipmentPlanDate: 'Плановая дата отгрузки',
  newConstructionCardCreated: 'Новая объектная карта добавлена',
  searchByConstructionCardId: 'Поиск по номеру объектной карты',
  answer: 'Ответ',
  answers: 'Ответы',
  product: 'Товар',
  discountCode: 'Код скидки',
  noAnswersInConstructionCard: 'По данной объектной карте нет ответов',
  supplier: 'Поставщик',
  transitMatrix: 'Транзитная матрица',
  position: 'Позиция',
  additionalConditions: 'Дополнительные условия',
  recommendedPriceForSale: 'Рекомендуемая цена продажи',
  stopPrice: 'Стоп-цена',
  validUntil: 'Действует до',
  minimumQuantity: 'Мин. количество',
  leadtime: 'До клиента дней',
  prodtime: 'До отгрузки, дней',
  deliveryInPrice: 'Доставка в цене',
  constructionCardSuccessfullyUpdated: 'Объектная карта обновлена',
  noConstructionCards: 'На данном объекте нет объектных карт',
  needHelp: 'Нужна помощь',
  acceptCard: 'Принять карту',
  cardDidntMatch: 'Карта не подошла',
  shouldPickCommodityGroup: 'Выберите товарную группу',
  shouldPickContractor: 'Выберите подрядчика',
};
